import React from 'react';
import { ChevronRight } from 'lucide-react';

export default function Footer({ onApplyClick }) {
  return (
    <footer style={{
      backgroundColor: '#07131E',
      color: '#94A3B8',
      padding: '3rem 0 2rem 0',
      borderTop: '2px solid #D4AF37',
      textAlign: 'center'
    }}>
      <div className="container">
        
        {/* CTA Container */}
        <div style={{
          backgroundColor: '#0F2537',
          borderRadius: '20px',
          padding: '2.5rem 1.5rem',
          border: '1px solid rgba(212, 175, 55, 0.3)',
          boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)',
          maxWidth: '800px',
          margin: '0 auto 2.5rem auto'
        }}>
          <h3 style={{ fontSize: '1.75rem', fontWeight: 800, color: '#FFFFFF', marginBottom: '0.5rem', letterSpacing: '-0.02em' }}>
            Ready to Advance Your Career with CHRIST Online?
          </h3>
          <p style={{ fontSize: '0.98rem', color: '#CBD5E1', marginBottom: '1.75rem', maxWidth: '560px', margin: '0 auto 1.75rem auto' }}>
            Apply for UGC Entitled Online Degree Programs today and get free academic counseling.
          </p>
          <button
            onClick={onApplyClick}
            className="btn-primary"
            style={{
              padding: '0.85rem 2.2rem',
              fontSize: '1rem',
              fontWeight: 700,
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.5rem'
            }}
          >
            Apply Now <ChevronRight size={18} />
          </button>
        </div>

        {/* Copyright Line */}
        <div style={{
          fontSize: '0.88rem',
          color: '#64748B',
          paddingTop: '1rem',
          borderTop: '1px solid rgba(255, 255, 255, 0.08)'
        }}>
          © 2026 CHRIST (Deemed to be University). All Rights Reserved.
        </div>

      </div>
    </footer>
  );
}
